import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { AirQualityMarkersResponseDto, AqiStandardId, NetworkId } from '../../types';
import { apiClient } from '../apiClient';
import { createQueryConfig } from '../config';

export const useGetAirQualityMarkers = ({
  network,
  aqiStandard,
}: {
  network: NetworkId;
  aqiStandard?: AqiStandardId;
}): UseQueryResult<AirQualityMarkersResponseDto | null> => {
  return useQuery({
    queryKey: ['air-quality-markers', network, aqiStandard],
    queryFn: async () => {
      if (!aqiStandard) {
        return null;
      }
      const { data } = (await apiClient.get('/v1/map/air-quality-markers', {
        params: {
          network,
          aqiStandard,
        },
      })) as { data: AirQualityMarkersResponseDto };

      return data;
    },
    ...createQueryConfig(),
  });
};
